import {
  TextField,
  FormField,
  formFieldRequiredLabel as requiredLabel,
  PasswordField,
} from '@elementary/common-ui/components';
import { useFormContext } from 'react-hook-form';
import { validatePort } from './utils';

const ClickhouseFormContent = ({ disabled }: { disabled?: boolean }) => {
  const methods = useFormContext();
  const {
    register,
    formState: { errors, dirtyFields },
  } = methods;

  return (
    <>
      <FormField
        title="Host"
        errorMessage={errors.clickhouseHost?.message as string}
      >
        <TextField
          {...register('clickhouseHost', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. hostname.us-west-2.rds.amazonaws.com"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Port"
        errorMessage={errors.clickhousePort?.message as string}
      >
        <TextField
          {...register('clickhousePort', {
            required: requiredLabel,
            validate: validatePort,
          })}
          variant="outlined"
          placeholder="8443"
          defaultValue="8443"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="User"
        errorMessage={errors.clickhouseUser?.message as string}
      >
        <TextField
          {...register('clickhouseUser', {
            required: requiredLabel,
          })}
          variant="outlined"
          placeholder="e.g. elementary_user"
          disabled={disabled}
          size="large"
        />
      </FormField>
      <FormField
        title="Password"
        errorMessage={errors.clickhousePassword?.message as string}
      >
        <PasswordField
          {...register('clickhousePassword', {
            required: requiredLabel,
          })}
          isFormValueDirty={dirtyFields.clickhousePassword}
          clearFormValue={() => methods.setValue('clickhousePassword', '')}
          placeholder="Password"
          disabled={disabled}
          size="large"
        />
      </FormField>
    </>
  );
};

export default ClickhouseFormContent;
